module.exports = __webpack_public_path__ + "static/13_PLATOS-POL-PIEROGI-D.abb8e98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/foods/13_PLATOS-POL-PIEROGI-D.png
// module id = 658
// module chunks = 35783957827783